// src/api/product/productApi.ts
import { axiosInstance } from "src/api/axiosInstance";
import type { ApiResponse } from "src/api/common/apiTypes";
import type {
  ProductItem,
  ProductListItem,
  ProductListResponse,
  GetProductListParams,
  ProductUpsertBody,
  ProductDetail,
  ProductImageGroup,
} from "src/types/product";

// LIST
export const getProductListApi = async (
  params: GetProductListParams
): Promise<ApiResponse<ProductListResponse>> => {
  const res = await axiosInstance.get<ApiResponse<ProductListResponse>>(
    "/v1/admin/baseinfo/product/list",
    {
      params: {
        productName: params.productName || undefined,
        brandId: params.brandId ?? undefined,
        collectionId: params.collectionId ?? undefined,
        saleStatus: params.saleStatus || undefined,
        productType: params.productType || undefined,
        petType: params.petType || undefined,
        isDisplay: typeof params.isDisplay === "boolean" ? params.isDisplay : undefined,
        page: params.page,
        size: params.size,
        order: params.order,
        include: params.include,
      },
    }
  );
  return res.data;
};

// DETAIL
export const getProductApi = async (id: number): Promise<ApiResponse<ProductItem>> => {
  const res = await axiosInstance.get<ApiResponse<ProductItem>>(`/v1/admin/baseinfo/product/${id}`);
  return res.data;
};

// CREATE (JSON)
export const createProductApi = async (
  payload: ProductUpsertBody
): Promise<ApiResponse<ProductItem>> => {
  const res = await axiosInstance.post<ApiResponse<ProductItem>>(
    "/v1/admin/baseinfo/product",
    payload
  );
  return res.data;
};

// UPDATE (JSON)
export const updateProductApi = async (
  id: number,
  payload: ProductUpsertBody
): Promise<ApiResponse<ProductItem>> => {
  const res = await axiosInstance.put<ApiResponse<ProductItem>>(
    `/v1/admin/baseinfo/product/${id}`,
    payload
  );
  return res.data;
};

// DELETE
export const deleteProductApi = async (id: number): Promise<ApiResponse<null>> => {
  const res = await axiosInstance.delete<ApiResponse<null>>(`/v1/admin/baseinfo/product/${id}`);
  return res.data;
};

export type { ProductItem, ProductListItem, ProductDetail, ProductImageGroup };
